import { Component, OnInit, inject } from '@angular/core';

import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-success-error-report-modal',
  templateUrl: './success-error-report-modal.component.html',
  styleUrls: ['./success-error-report-modal.component.scss'],
})
export class SuccessErrorReportModalComponent implements OnInit {
  private modalController = inject(ModalController);

  constructor() {}

  ngOnInit() {}

  close() {
    this.modalController.dismiss();
  }
}
